import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationSharedService {
  private itemCount = new BehaviorSubject<number>(0);

  setItemCount(count: number) {
    this.itemCount.next(count);
  }

  getItemCount() {
    return this.itemCount.asObservable();
  }
}